export class Page {

  constructor(
    public pageIndex: number,
    public pageSize: number) {
  }
}
